import React from 'react'
import { Typography } from '@mui/material'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import {
  faArrowLeft,
  faArrowDownToLine,
} from '@fortawesome/pro-regular-svg-icons'
import { useNavigate } from 'react-router-dom'
import { ShortenedNameV2 } from '@labrav/common'
import { labravDefaultThemeV7 as theme } from '@labrav/react-components'
import GcpLogo from '../../../../common/images/gcpCloudNew.svg'

interface SubscriptionHeaderProps {
  offerDetailInfo: {
    companyName?: string
    offerName?: string
    offerType?: string
  }
  subscriptionDetail: any
  classes: any
  isBack: boolean
  cloudType?: string
}

export const SubscriptionHeader: React.FC<SubscriptionHeaderProps> = ({
  offerDetailInfo,
  subscriptionDetail,
  classes,
  isBack,
  cloudType,
}) => {
  const navigate = useNavigate()

  if (cloudType === 'GCP') {
    return (
      <div className={classes.headerSectionV2}>
        <div className={classes.headerLeftV2}>
          {isBack && (
            <div
              className={classes.backButton}
              data-testid="back-button"
              onClick={() => navigate(-1)}
            >
              <FontAwesomeIcon
                icon={faArrowLeft}
                style={{
                  width: theme.spacing(2.25),
                  height: theme.spacing(2.5),
                  fontSize: theme.spacing(3),
                  color: theme.palette.select.light,
                }}
              />
            </div>
          )}
          <div className={classes.headerNameArea}>
            <Typography className={classes.headerOfferName}>
              {offerDetailInfo?.offerName || '-'}
            </Typography>
            {offerDetailInfo?.offerType && (
              <span className={classes.headerOfferTypeBadge}>
                {offerDetailInfo.offerType}
              </span>
            )}
          </div>
        </div>

        <div className={classes.headerRightV2}>
          <button
            className={classes.headerDownloadBtn}
            onClick={() => window.print()}
            data-testid="gcp-download-pdf"
          >
            <FontAwesomeIcon
              icon={faArrowDownToLine}
              style={{
                width: theme.spacing(1.75),
                height: theme.spacing(1.75),
                color: theme.palette.labraText.primary,
              }}
            />
            <Typography className={classes.headerDownloadBtnText}>
              Download as PDF
            </Typography>
          </button>
          <div className={classes.headerCloudIconWrap}>
            <img
              src={GcpLogo}
              alt="GCP"
              style={{ width: '100%', height: '100%', objectFit: 'contain' }}
            />
          </div>
        </div>
      </div>
    )
  }

  return (
    <div className={classes.headerSection}>
      <div className={classes.headerLeft}>
        {isBack && (
          <div
            className={classes.backButton}
            data-testid="back-button"
            onClick={() => navigate(-1)}
          >
            <FontAwesomeIcon
              icon={faArrowLeft}
              style={{
                width: theme.spacing(2.25),
                height: theme.spacing(2.5),
                fontSize: theme.spacing(3),
                color: theme.palette.select.light,
              }}
            />
          </div>
        )}
        <Typography
          variant="h1"
          data-testid="heading"
          className={classes.appTitleHeadingText}
        >
          <ShortenedNameV2
            name={`${
              offerDetailInfo?.companyName
                ? `${offerDetailInfo?.companyName}`
                : ''
            } ${
              subscriptionDetail?.productDetails?.productName
                ? `'s- ${subscriptionDetail?.productDetails?.productName}`
                : ''
            }`}
            length={41}
          />
        </Typography>
      </div>
    </div>
  )
}
